// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--2y2X1","empty":"a10a3f92e9--empty--1-UUy","title_block":"a10a3f92e9--title_block--1d4OY","list":"a10a3f92e9--list--3UcwL"};